// V1E6B2: Children’s Book logical Matter only. No Novel persistence or physical pages.
import {sceneFirstEligibleV1E5C} from './childrensBookSceneFirstAuthorV1E5C';
import {normalizeManuscriptContent} from './childrensBookManuscriptContent';
const clean=value=>typeof value==='string'?value.trim():'';
const fail=code=>({ok:false,code});
const EMPTY=()=>({version:1,blocks:[]});
const limits={perSection:50,total:90,maxTitle:240,maxId:120};
export function sceneFirstMatterV1E6B2(draft={}) {
  if(!sceneFirstEligibleV1E5C(draft)) return fail('scene_first_only');
  const collection=draft?.manuscriptPlan?.bookMatterDrafts;
  if(collection===undefined) return {ok:true,matter:{version:1,front:[],back:[]}};
  if(!collection||collection.version!==1||!Array.isArray(collection.front)||
     !Array.isArray(collection.back)) return fail('invalid_book_matter');
  if(collection.front.length>limits.perSection||collection.back.length>limits.perSection||
     collection.front.length+collection.back.length>limits.total) return fail('matter_limit');
  const seen=new Set();
  for(const kind of ['front','back']) for(const row of collection[kind]) {
    if(!row||typeof row!=='object'||Array.isArray(row)||
      Object.keys(row).some(key=>!['id','title','manuscriptContent'].includes(key)) ||
      !clean(row.id)||row.id.length>limits.maxId||!clean(row.title)||
      row.title.length>limits.maxTitle||seen.has(row.id)||!row.manuscriptContent)
      return fail('invalid_book_matter');
    seen.add(row.id);
  }
  return {ok:true,matter:collection};
}
export function addSceneFirstMatterV1E6B2(draft,kind,id,title) {
  const result=sceneFirstMatterV1E6B2(draft);
  if(!result.ok)return result;
  if(!['front','back'].includes(kind))return fail('invalid_section');
  const {matter}=result;
  if(!clean(id)||id.length>limits.maxId||!clean(title)||title.length>limits.maxTitle||
     matter[kind].length>=limits.perSection||
     matter.front.length+matter.back.length>=limits.total||
     [...matter.front,...matter.back].some(row=>row.id===id)) return fail('invalid_matter_identity');
  return {ok:true,matter:{...matter,[kind]:[...matter[kind],
    {id,title:clean(title),manuscriptContent:EMPTY()}]}};
}
export function editSceneFirstMatterV1E6B2(draft,kind,id,change={}) {
  const result=sceneFirstMatterV1E6B2(draft);
  if(!result.ok)return result;
  if(!['front','back'].includes(kind)||!clean(id))return fail('invalid_section');
  if(!change||typeof change!=='object'||Array.isArray(change)||
     Object.keys(change).some(key=>!['title','manuscriptContent'].includes(key)))return fail('invalid_matter_change');
  const current=result.matter[kind].find(row=>row.id===id);
  if(!current)return fail('unknown_matter_item');
  const next={...current};
  if(Object.prototype.hasOwnProperty.call(change,'title')) {
    if(!clean(change.title)||change.title.length>limits.maxTitle)return fail('invalid_matter_title');
    next.title=change.title; // Author controls the title; preserve unfinished spaces while editing.
  }
  if(Object.prototype.hasOwnProperty.call(change,'manuscriptContent')) {
    const normalized=normalizeManuscriptContent(change.manuscriptContent);
    if(!normalized.ok||!normalized.content)return fail('invalid_manuscript_content');
    next.manuscriptContent=normalized.content;
  }
  return {ok:true,matter:{...result.matter,[kind]:result.matter[kind].map(row=>row.id===id?next:row)}};
}
export const sceneFirstMatterTemplatesV1E6B2={
  front:['Title Page','Copyright','Dedication','Acknowledgements','Preface','Introduction','Table of Contents'],
  back:['Author’s Note','About the Author','Appendix','Glossary','Index'],
};
